import {
  createSlice,
  createEntityAdapter,
  createAsyncThunk,
   createSelector,
} from '@reduxjs/toolkit'
import { parse } from 'date-fns';


import requestService from '../services/requestService'
import { generatePhoneDetail } from '../utils/phoneUtil';



export const fetchRequests = createAsyncThunk('request/fetchRequests', 
  async (_, {getState}) => {

    const timestamp =selectMaxPendingRequestTimeStamp(getState()) ;
    const response = await requestService.fetchIncrement(timestamp)
    return response.data
})


export const allowRequest = createAsyncThunk('request/allowRequest', 
  async (action) => {
    const response = await requestService.allow(action)
    return response.data
})

export const denyRequest = createAsyncThunk('request/denyRequest', 
  async (action) => {
    const response = await requestService.deny(action)
    return response.data
})

export const deleteRequest = createAsyncThunk('request/deleteRequest', 
  async (id) => {
    const response = await requestService.delete(id)
    return response.data
})


const maxTimestamp=(list)=>{
  return list.map(x=>x.id).reduce( (e,f)=>Math.max(e,f))
          
}


const requestAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
  sortComparer: (a, b) => 0-(a.id - b.id)
})

const initialState = requestAdapter.getInitialState({
  status: 'idle',
  error: null,
  
  });


const requestSlice = createSlice({
  name: 'request',
  initialState: initialState,
  reducers: {
    requestsSyncLoaded: {
      reducer(state, action) {

        if (action.payload)
        {
            action.payload.forEach(element => {
              generatePhoneDetail(element)
            });
        }
        requestAdapter.setAll(state, action.payload)
      },
       prepare(requeList) {
         return {payload: requeList}
       }
    },

    clearRequests(state, action) {
      state.error=null
      state.status='idle'
      //state.timestamp=0
      requestAdapter.removeAll(state)
    }

  },
  extraReducers(builder) {
    builder
      
      .addCase(fetchRequests.pending, (state, action) => {
        state.status = 'loading'
        state.error=null
      })
      .addCase(fetchRequests.fulfilled, (state, action) => {
        state.status = 'succeeded'
        if (action.payload)
        {
          action.payload.forEach(element => {
            generatePhoneDetail(element)
          });
        }
        requestAdapter.upsertMany(state, action.payload)
      })
      .addCase(fetchRequests.rejected, (state, action) => {
        state.status = 'failed'
    		//state.timestamp=0
        state.error = action.error.message
      })
      .addCase(allowRequest.fulfilled, (state, action) => {
          if (action.payload) 
          {
            generatePhoneDetail(action.payload)
  
            requestAdapter.upsertOne(state, action.payload)
          }
      })
      .addCase(denyRequest.fulfilled, (state, action) => {
        if (action.payload) 
          {
            generatePhoneDetail(action.payload)
            requestAdapter.upsertOne(state, action.payload)
          }
      })
      .addCase(deleteRequest.fulfilled, (state, action) => {
        requestAdapter.removeOne(state,action.payload)
      })
  }
})


export const { clearRequests, requestsSyncLoaded } = requestSlice.actions

export default requestSlice.reducer;

export const {
  selectAll:  selectAllRequests,
  selectById: xselectRequestById,
  selectIds:  selectRequestIds,
} = requestAdapter.getSelectors((state) => state.request)

export const selectRequestById = (id)=>(state)=>xselectRequestById(state, id)
export const selectRequestStatus = (state)=>state.request.status;
export const selectRequestError = (state)=>state.request.error;
export const selectRequestTimestame = (state)=>state.request.timestamp;



export const selectPendingRequestCount = createSelector(
  [selectAllRequests],
  (notifications) =>{
      let ns = notifications.filter(n => n.status==='PENDING')
  
      return Boolean(ns)? ns.length : 0
    }
)


export const selectMaxPendingRequestTimeStamp = createSelector(
  [selectAllRequests, (rs) => rs],
  (rs) =>{
    console.log(rs);
      if (rs && rs.length>0)
      {
        let arr = rs.map(x=> x.updatedTm ? parse(x.updatedTm, 'dd/MM/yyyy HH:mm:ss', new Date()) : 100000)
        return Math.max(...arr)
      }
      return 0;
    }
)



